import React from 'react'
import {
  Icon,
  Menu,
  Dropdown
} from 'antd'

import BookCard from './BookCard'

import {
  update
} from '../services/MyReadsAPI';

export default class CurrentlyReadingBookCard extends BookCard {
  state = {
    removed: false
  }

  render = () => {
    return <BookCard {...this.props} actions={this._renderActions} active={!this.state.removed}/>
  }

  _renderActions = () => {
    return [
      <Dropdown overlay={this._dropdown()}>
        <Icon type="ellipsis" />
      </Dropdown>
    ]
  }

  _dropdown = () => (
    <Menu onClick={this._dispatchAction}>
      <Menu.SubMenu key="sub1" title="Move to shelf">
        <Menu.Item key="wantToRead">
          <Icon type="check"/> Want to Read
        </Menu.Item>
        <Menu.Item key="read">
          <Icon type="book"/> Read
        </Menu.Item>
      </Menu.SubMenu>
      <Menu.Item key="noShelf">
        <Icon type="delete"/> Remove from shelf
      </Menu.Item>
    </Menu>
  );

  _dispatchAction = ({ item, key }) => {
    update({ id: this.props.id }, key).then(() => this.setState({ removed: true }));
  }
}



// WEBPACK FOOTER //
// ./src/components/CurrentReadingBookCard.js